import React, { type FC, type ReactNode, useEffect } from "react";
import { useNotificationStore } from "@app/services/notification";
import { NotificationToast } from "./NotificationToast";
import "./NotificationToast.scss";

interface NotificationProviderProps {
    children: ReactNode;
}

/**
 * Провайдер toast-уведомлений: подписка на стор и автоудаление по duration.
 */
export const NotificationProvider: FC<NotificationProviderProps> = ({ children }) => {
    const notifications = useNotificationStore((s) => s.notifications);
    const removeNotification = useNotificationStore((s) => s.removeNotification);
    const closeNotification = useNotificationStore((s) => s.closeNotification);
    const clearNotifications = useNotificationStore((s) => s.clearNotifications);

    useEffect(() => {
        clearNotifications();
    }, [clearNotifications]);

    useEffect(() => {
        const timers = new Map<string, ReturnType<typeof setTimeout>>();
        const now = Date.now();

        for (const item of notifications) {
            if (item.duration === "infinite") {
                continue;
            }
            const remaining = item.timestamp + item.duration - now;
            if (remaining <= 0) {
                removeNotification(item.id);
            } else {
                const timer = setTimeout(() => removeNotification(item.id), remaining);
                timers.set(item.id, timer);
            }
        }

        return () => {
            for (const timer of timers.values()) {
                clearTimeout(timer);
            }
        };
    }, [notifications, removeNotification]);

    return (
        <>
            {children}
            <div className="app_notification_container" role="region" aria-live="polite" aria-relevant="additions">
                {notifications.map((item) => (
                    <NotificationToast
                        key={item.id}
                        notification={item}
                        onClose={closeNotification}
                        onRemove={removeNotification}
                    />
                ))}
            </div>
        </>
    );
};
